import LearningPage from '../components/analytics/learning/LearningPage';

const LearningAnalyticsPage = () => <LearningPage />;

export default LearningAnalyticsPage;
